@if (type == 'short') {
  <app-default-score-short
    [data]="dataNew"
    [sport]="sportName"
    [onlyPeriods]="onlyPeriods"
    [match_state]="matchState"
    [codeState]="codeState"
    [oneline]="oneline"
    [onlyFinal]="onlyFinal"
  ></app-default-score-short>
}
@if (type == 'full') {
  <app-default-score
    class="app-default-score"
    [sport]="sportName"
    [codeState]="codeState"
    [data]="dataNew"
    [match_state]="matchState"
    [onlyPeriods]="onlyPeriods"
    [oneline]="oneline"
    [head]="head"
    [possession]="possession"
  ></app-default-score>
}
@if (type == 'match-detail') {
  <app-match-detail-score
    class="app-default-score"
    [data]="dataNew"
    [sport]="sportName"
    [participants]="participants"
    [match_state]="matchState"
    [onlyPeriods]="onlyPeriods"
    [oneline]="oneline"
    [head]="head"
    [possession]="possession"
  ></app-match-detail-score>
}
